export default "__VITE_ASSET__BEofrWkS__"